//M10-11561
import axios, { AxiosInstance } from "axios";
import { api } from "src/constants/global-const";
import { addAuthHeader } from "src/utils/auth";
import { attachRefreshInterceptor, acceptExceptAuthErrors } from "src/utils/axiosRefreshInterceptor";

let instance: AxiosInstance;
// let eventInstance: AxiosInstance;

const axiosInstance = async () => {
    instance = axios.create({
        baseURL: api + "/oms",
    });
    // Attach 403 refresh-and-retry interceptor
    attachRefreshInterceptor(instance);

    instance.interceptors.request.use((config) => addAuthHeader(config));
};

axiosInstance();

interface ApiResponse {
    success: boolean;
    message: string;
    data?: any;
    status: number | string;
    // Add other properties as needed
}

export const getOrderTypeExceptionValidation = async (payload: any): Promise<ApiResponse> => {
    return instance.post(`/order/validation`, payload, {
        validateStatus: acceptExceptAuthErrors,
    });
}

export const getBulkOrderValidation = async (payload: any): Promise<ApiResponse> => {
    return instance.post(`/order/bulk-order/validate`, payload, {
        validateStatus: acceptExceptAuthErrors,
    });
}
//M10-11561